import { c as _c } from "react/compiler-runtime";
import { callToAction } from '@/uiComposites/interactive/callToAction';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { useFormStatus } from 'react-dom';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
export const SubmitButton = t0 => {
  const $ = _c(9);
  const {
    text,
    loadingText,
    errorText,
    isRejected
  } = t0;
  const {
    pending
  } = useFormStatus();
  let t1;
  if ($[0] !== isRejected || $[1] !== pending) {
    t1 = classes(zIndex({
      zIndex: "1"
    }), callToAction({
      box: isRejected && !pending ? {
        backgroundColor: "positiveRed"
      } : undefined
    }));
    $[0] = isRejected;
    $[1] = pending;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = addTestSelector("uiFeedbackSubmitButton");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = pending ? loadingText : isRejected ? errorText : text;
  let t4;
  if ($[4] !== t3) {
    t4 = <span role="alert">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <button type="submit" className={t1} {...t2}>{t4}</button>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};